export type Testimonial = {
  id: string
  quote: string
  attribution: string
  location: string
}

const placeholderQuote = '[INSERT VERIFIED CUSTOMER TESTIMONIAL]'

export const testimonials: Testimonial[] = [
  {
    id: 'testimonial-1',
    quote: placeholderQuote,
    attribution: 'Verified Tap Dance Instructor',
    location: 'Location',
  },
  {
    id: 'testimonial-2',
    quote: placeholderQuote,
    attribution: 'Verified Tap Dance Instructor',
    location: 'Location',
  },
  {
    id: 'testimonial-3',
    quote: placeholderQuote,
    attribution: 'Verified Tap Dance Instructor',
    location: 'Location',
  },
]
